import React from "react";

export function ArchitectureGlyph({ kind }) {
  return <span className={`direction-b-glyph direction-b-glyph--${kind}`} aria-hidden="true" />;
}

export default function ArchitectureFlow({ flow, orientation = "horizontal", label }) {
  return (
    <div className={`direction-b-flow direction-b-flow--${orientation}`} aria-label={label}>
      <div className="direction-b-flow__visual" aria-hidden="true">
        {flow.map((node, index) => (
          <React.Fragment key={`${node.label}-${index}`}>
            <div className="direction-b-flow__node">
              <ArchitectureGlyph kind={node.kind} />
              <span>{node.label}</span>
            </div>
            {index < flow.length - 1 && <span className="direction-b-flow__line" aria-hidden="true" />}
          </React.Fragment>
        ))}
      </div>
      <ol className="direction-b-sr-list">
        {flow.map((node) => <li key={node.label}>{node.label}</li>)}
      </ol>
    </div>
  );
}

export function NotationKey() {
  const items = [
    ["system", "system"],
    ["decision", "model decision"],
    ["boundary", "deterministic boundary"],
    ["gate", "evaluated gate"],
  ];
  return (
    <div className="direction-b-notation" aria-label="Architecture notation key">
      <span className="direction-b-mono-label">Notation</span>
      {items.map(([kind, text]) => <span className="direction-b-notation__item" key={kind}><ArchitectureGlyph kind={kind} />{text}</span>)}
      <span className="direction-b-notation__item"><span className="direction-b-notation__rule" />control flow</span>
    </div>
  );
}
